export default __webpack_public_path__ + "static/media/3.ee797fd5.jpg";